import { render, staticRenderFns } from "./PayoutMethodApprovals.vue?vue&type=template&id=fd43bafa&"
import script from "./PayoutMethodApprovals.vue?vue&type=script&lang=js&"
export * from "./PayoutMethodApprovals.vue?vue&type=script&lang=js&"
import style0 from "./PayoutMethodApprovals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports